import PropTypes from 'prop-types'
import React from 'react'
import classes from './Home.scss'

import Summary from 'components/Orders/Summary'
import Pricelist from 'components/Pricelist'

export const Home = (props) => {
  return (
    <div className={classes['dual-view']}>
      {!!props.orders.length && <Summary {...props} />}
      <Pricelist {...props} />
    </div>
  )
}

Home.propTypes = {
  orders: PropTypes.array
}

Home.defaultProps = {
  orders: []
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/Home.js